import React from "react"
import { Tab, Tabs } from "react-bootstrap"
import { ECOMMERCE_CONFIGURATION_TYPE } from "../../../state/ecommerce-configuration/EcommerceTypes"
import { FormattedMessage } from "react-intl"
type OwnProps = {
    activeTab: ECOMMERCE_CONFIGURATION_TYPE
    onChangeCallback: (tab: ECOMMERCE_CONFIGURATION_TYPE) => void
}

const EcommerceConfigurationTabs = (props: OwnProps) => {
    return (
        <Tabs activeKey={props.activeTab} onSelect={(k) => props.onChangeCallback(k as ECOMMERCE_CONFIGURATION_TYPE)} >
            <Tab eventKey={ECOMMERCE_CONFIGURATION_TYPE.QUOTE_CART} title={<FormattedMessage
                id="ecommerce.components.ecommerce_tab.quote_cart_label"
                defaultMessage="Quote Cart"
            />}>
            </Tab>

            <Tab eventKey={ECOMMERCE_CONFIGURATION_TYPE.FLOATING_QUOTE_BUTTON} title={<FormattedMessage
                id="ecommerce.components.ecommerce_tab.floating_quote_cart_button"
                defaultMessage="Floating Quote Cart Button"
            />}>
            </Tab>
            <Tab eventKey={ECOMMERCE_CONFIGURATION_TYPE.QUOTE_FORM} title={<FormattedMessage
                id="ecommerce.components.ecommerceTab.quote_form"
                defaultMessage="Quote Form"
            />}>
            </Tab>

            <Tab eventKey={ECOMMERCE_CONFIGURATION_TYPE.ADD_TO_QUOTE_BUTTON} title={<FormattedMessage
                id="ecommerce.components.ecommerce_tab.add_to_quote_button"
                defaultMessage="Add To Quote Button"
            />}>
            </Tab>

            <Tab eventKey={ECOMMERCE_CONFIGURATION_TYPE.RULES} title={<FormattedMessage
                id="ecommerce.components.ecommerceTab.rules"
                defaultMessage="Rules Engine"
            />}>
            </Tab>
        </Tabs>
    )

}

export default EcommerceConfigurationTabs


// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceTabsComponent.tsx